export default __webpack_public_path__ + "static/media/TeresaTeam.11367fec.png";